import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/branches',
    name: 'branch',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/branch/index.vue')
  },
  {
    path: '/branches/create',
    name: 'branch-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/branch/create.vue'),
    props: route => ({ companies: route.params.companies })
  },
  {
    path: '/branches/:id',
    name: 'branch-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/branch/edit.vue'),
    props: route => ({
      editData: route.params.editData,
      companies: route.params.companies
    })
  }
]
